import { useEffect, useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { AddIcon } from "../../../assets/icons";
import { TableLoader } from "../../../components/Loader";
import UseGetData from "../../../hooks/useFetchData";
import CreateOrUpdate from "./form";
import axiosInstance from "../../../services/axiosComman";
import ViewMore from "./viewMore";

function UserRoleIndex() {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [role, setRole] = useState([]);
  const [user, setUser] = useState([]);
  const [showMyMenu, setShowMyMenu] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenu(false);
  const { data, getData, isLoading } = UseGetData({ url: "/User-Role/" });
  //   console.log("Settt",data);
  const getRole = () => {
    axiosInstance.get("/Role/").then((res) => {
      res?.data && setRole(res?.data?.data);
    });
  };

  const getUser = () => {
    axiosInstance.get("/User/").then((res) => {
      let item = res?.data?.userDetails;
      let final = [];
      res?.data?.userDetails &&
        item.forEach((item) => {
          let temData = item?.user;
          final.push(temData);
        });
      res?.data && setUser(final);
    });
  };

  useEffect(() => {
    getRole();
    getUser();
  }, []);
  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Role
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th className={`text-center px-5 py-4 ${header.width}`}>
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(8)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center text-gray-900 py-1 w-[15%]`}
                        >
                          {data.number || "#"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[40%]`}
                        >
                          {data?.role?.user || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[40%]`}
                        >
                          {data?.role?.role || "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore
                              onClose={handleOnCloseMenu}
                              visible={showMyMenu}
                              data={data?.role}
                              fetcher={getData}
                              user={user}
                              role={role}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
      <CreateOrUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        refreshData={getData}
        role={role}
        user={user}
      />
    </>
  );
}

export default UserRoleIndex;

const header = [
  {
    headone: "SI.No",
    width: "w-[15%]",
  },
  {
    headone: "User Name",
    width: "w-[40%]",
  },
  {
    headone: "Role",
    width: "w-[40%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
